<template>
    <table>
        <thead>
            <tr>
                <th colspan="3">Historique d'affectation</th>
            </tr>
            <tr>
                <th>Affectation</th>
                <th>Début de l'affectation</th>
                <th>Fin de l'affectation</th>
            </tr>
        </thead>
        <tbody v-if="affectationHistory?.length > 0">
            <tr v-for="affectation in affectationHistory">
                <td>{{ affectation.assigned_to }}</td>
                <td>{{ new Date(affectation.assigned_date).toLocaleString('fr-FR') }}</td>
                <td v-if="affectation.checkout_date">{{ new Date(affectation.checkout_date).toLocaleString('fr-FR') }}</td>
                <td v-else-if="!affectation.checkout_date && affectation.assigned_to == 'Inventaire'">Actuellement dans l'inventaire</td>
                <td v-else>Actuellement assigné à {{ affectation.assigned_to }}</td>
            </tr>
        </tbody>
        <tbody v-else>
            <tr>
                <td colspan="3" class="text-center">Pas d'historique à afficher</td>
            </tr>
        </tbody>
    </table>
    <aside>
        <Pagination
            :totalCount="total_count" 
            v-model:page="page"
            v-model:pageSize="page_size"
        ></Pagination>
    </aside>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import apiClient                 from '@/api'
import Pagination                from '@/components/Pagination.vue'

const props = defineProps({
    computerId: Number
})

const affectationHistory = ref([])

// pagination
const page        = ref(1)
const page_size   = ref(10)
const total_count = ref(0)

const get_affectation_history = async (id) => {
    const params = {
        id: id,
        page: page.value,
        page_size: page_size.value
    }

    try {
        const response = await apiClient.get('get_affectation_history/', { params })
        const data = response.data
        console.log(data)

        if(data.results.data !== undefined) {
            affectationHistory.value = data.results.data
        } else {
            affectationHistory.value = []
        }

        if (data.count !== undefined) {
            console.log(data.count)
            total_count.value = data.count
        } else {
            total_count.value = affectationHistory.value.length
        }

        
    } catch (error) {
        if (error.response) {
            console.log('Status :', error.response.status, ' | ', error.response.data.message)
        } else if (error.request) {
            console.log(error.request)
        } else {
            console.log(error.message)
        }
    }
}

watch(() => props.computerId, (newId) => {
    if (newId) get_affectation_history(newId)
})

watch ([page, page_size], () => {
    if (props.computerId) get_affectation_history(props.computerId)
})

onMounted( async () => {
    if (props.computerId) get_affectation_history(props.computerId)
})

// allows to refresh whenever the parent updates the inventory
defineExpose({
    refetch() {
        if (props.computerId) get_affectation_history(props.computerId)
    }
})
</script>

<style lang="scss" scoped>
    .text-center {
        text-align: center;
    }
</style>